// payment.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { paymentService } from "../../services/paymentService";

// Define initial state for payment module
const initialState = {
  loading: false,
  PaymentStatus: 0,
};

export const fetchPaymentHistory = createAsyncThunk(
  "profile/fetchPaymentHistory",
  async () => {
    try {
      const response = await paymentService.getPaymentHistory();
      return response?.data?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      throw error;
    }
  }
);

// Create the payment slice
const payment = createSlice({
  name: "payment",
  initialState,
  reducers: {
    handlePaymentStatus: (state, action) => {
      state.PaymentStatus = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPaymentHistory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchPaymentHistory.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

// Export the profile actions and reducer
export const { handlePaymentStatus } = payment.actions;
export default payment.reducer;
